module.exports = __webpack_public_path__ + "static/media/jaemin-3.jpeg";